/** Určuje styl otevření */
export enum OpenOn {
    Click = "Click",
    Hover = "Hover",
    ClickAndHover = "ClickAndHover",
}
